import { createContext, useContext } from "react";

/**
 * The "center column" element from {@link ViewWrapper} — the main content region
 * that shrinks when the right sidebar opens. Artifact lightboxes portal into it
 * so they stay scoped to (and re-center within) the main area instead of
 * covering the full viewport and the sidebar. Null outside a ViewWrapper, in
 * which case lightboxes fall back to their full-viewport behavior.
 */
const MainAreaPortalContext = createContext<HTMLElement | null>(null);

export const MainAreaPortalProvider = MainAreaPortalContext.Provider;

export const useMainAreaPortalEl = (): HTMLElement | null => useContext(MainAreaPortalContext);
